import { ParticleWaveBackground } from '../lib/ParticleWaveBackground';
import ScrollTrigger from 'gsap/ScrollTrigger';
import { isElementPartiallyInViewport } from '../lib/viewport';
import { md } from '../common';

export function initWaveBg(parent) {
  if (!parent || parent.dataset.waveBgLazyInit === 'true') return;

  parent.dataset.waveBgLazyInit = 'true';

  const inner = parent.querySelector('.wave-bg__inner');

  if (!inner) return;

  const animation = new ParticleWaveBackground(inner, {
    planeWidth: 12.996,
    planeHeight: 10.431,
    widthSegments: 140,
    heightSegments: 100,
    particleSize: 0.015,
    waveHeight: 0.844,
    noiseScale: 3,
    animationSpeed: 9000,
    gradient: [
      { color: [1.0, 0.1882, 0.0, 1], stop: 0 },
      { color: [1.0, 0.1882, 0.0, 0], stop: 100 },
    ],
    rotation: {
      x: -0.797964534011807,
      y: 0.282743338823081,
      z: -0.0251327412287183,
    },
    cameraPosition: [-3.04, -0.58, 10.431],
    cameraRotation: { x: 0, y: 0, z: 0 },
    autoStart: false,
    breakpoints: {
      1024: {
        widthSegments: 200,
        heightSegments: 128,
        particleSize: 0.0125,
        waveHeight: 0.844,
      },
    },
  });

  const startConditionalAnimation = () => {
    try {
      if (
        !parent.classList.contains('animated-gte-md')
        || (window && window.innerWidth >= md)
      ) {
        animation.startAnimation();
      }
    } catch (e) {
      console.error(e);
      animation.startAnimation();
    }
  }

  ScrollTrigger.create({
    trigger: inner,
    start: 'top bottom',
    end: 'bottom top',
    onEnter: () => startConditionalAnimation(),
    onLeave: () => animation.stopAnimation(),
    onEnterBack: () => startConditionalAnimation(),
    onLeaveBack: () => animation.stopAnimation(),
  });

  if (isElementPartiallyInViewport(inner)) {
    startConditionalAnimation();
  }
}

export function initWaveBgs(selector = '.js-wave-bg') {
  const blocks = document.querySelectorAll(selector);
  blocks.forEach((block) => initWaveBg(block));
}
